import { useState, useCallback } from "react";
import Toast from "./Toast";
import ToastContext from "../../context/ToastContext";
import "./toast.css"

function ToastProvider({ children }) {
  const [toasts, setToasts] = useState([]);

  const showToast = useCallback((message, type = "success", duration = 3000) => {
    const id = Date.now();

    setToasts((prev) => [...prev, { id, message, type }]);

    setTimeout(() => {
      setToasts((prev) => prev.filter((t) => t.id !== id));
    }, duration);
  }, []);

  const contextValue = {
    toast: {
      success: (msg, duration) => showToast(msg, "success", duration),
      error: (msg, duration) => showToast(msg, "error", duration),
      info: (msg, duration) => showToast(msg, "info", duration),
      warning: (msg, duration) => showToast(msg, "warning", duration),
    },
  };

  return (
    <ToastContext.Provider value={contextValue}>
      {children}
      <div className="toast-container">
        {toasts.map((t) => (
          <Toast key={t.id} message={t.message} type={t.type} />
        ))}
      </div>
    </ToastContext.Provider>
  );
}

export default ToastProvider;
